export const SEALED_CONTENT_PLACEHOLDER = '[sealed]';
